<template>
  <div class="assign-permission">
    <Form :model="formData" :label-width="80">
      <FormItem label="当前用户">
        <p v-html="formData.name" style="width: 360px;"></p>
      </FormItem>
      <FormItem label="权限配置">
        <HmTransfer
            ref="transfer"
            :data="data"
            :titles="['可分配权限', '已分配权限']"
            :target-keys="targetKeys"
            :list-style="listStyle"
            filterable
            :showCheckBox="false"
            @on-change="handleChange">
        </HmTransfer>
      </FormItem>
    </Form>

  </div>

</template>
<script>
import { Assignment } from '@/services/resources'
import HmTransfer from '@/components/widget/transfer'

import Storage from '@/services/storage'

export default {
  name: 'assignmentPage',
  components: { HmTransfer },
  data () {
    return {
      formData: {},
      targetKeys: [],
      data: [],
      selectedKeys: [],
      listStyle: {
        width: '42%',
        height: '600px'
      }
    }
  },
  created () {
    // 获取编辑的用户id
    let id = this.$route.params.id
    if (id) {
      Storage.setItem('Assign-User-Id', id)
    } else {
      id = Storage.getItem('Assign-User-Id')
    }
    this.loadAssignment(id)
    this.id = id
  },
  methods: {
    async loadAssignment (id) {
      let resp = await Assignment.get({ id }, true)
      this.formData.name = resp.data.name
      let { children, availables } = resp.data
      let _t = []
      let _c = children.map(item => {
        _t.push(item.name)
        return { key: item.name }
      })
      let _a = availables.map(item => {
        return { key: item.name }
      })
      this.data = [ ..._c, ..._a ]
      this.targetKeys = _t
    },
    async handleChange (newTargetKeys, direction, moveKeys) {
      let params = { items: moveKeys }
      let method = direction === 'left' ? 'deleteAssignment' : 'addAssignment'
      await Assignment[method](this.id, params)
      this.targetKeys = newTargetKeys
    },
    reloadMockData () {
      this.loadData()
      this.$refs.transfer.refresh()
    }
  }
}
</script>

<style lang="scss">
.assign-permission {
  .ivu-transfer-list{
    background: #fff;
  }
  margin-top: 20px;
}
</style>
